import styles from './FieldError.module.css';

/**
 * The message line under a form field. The line is always rendered and keeps one line of height
 * when empty, so showing or clearing a message doesn't push the rest of the form around; longer
 * messages (the password rules) still grow it.
 *
 * `className` replaces the default style (the auth pages use Flutter's error style, without the
 * reserved line).
 *
 * Pair it with the input: `aria-invalid={!!message}` and `aria-describedby={id}` (see
 * fieldErrorProps), so screen readers read the message with the field. Changes are announced
 * politely while the user is on the form.
 */
export function FieldError({ id, message, className }: { id: string; message?: string; className?: string }) {
  return (
    <span id={id} className={className ?? styles.error} aria-live="polite">
      {message}
    </span>
  );
}

/** aria-invalid / aria-describedby for the input that FieldError `id` describes. */
export function fieldErrorProps(id: string, message: string | undefined) {
  return {
    'aria-invalid': message ? true : undefined,
    'aria-describedby': message ? id : undefined,
  } as const;
}
